var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M15.8875 14.3333C15.8875 14.64 15.6381 14.8889 15.332 14.8889H8.66529C8.35917 14.8889 8.10973 14.64 8.10973 14.3333V10.4444H15.8875V14.3333ZM9.77679 7.6667C10.0835 7.6667 10.3323 7.91504 10.3323 8.22226C10.3323 8.52948 10.0835 8.77781 9.77679 8.77781C9.47012 8.77781 9.22124 8.52948 9.22124 8.22226C9.22124 7.91504 9.47012 7.6667 9.77679 7.6667ZM12.0007 7.6667C12.3074 7.6667 12.5562 7.91504 12.5562 8.22226C12.5562 8.52948 12.3074 8.77781 12.0007 8.77781C11.694 8.77781 11.4451 8.52948 11.4451 8.22226C11.4451 7.91504 11.694 7.6667 12.0007 7.6667ZM15.3333 6H8.66667C7.74778 6 7 6.74778 7 7.66667V9.33333V10.4444V14.3333C7 15.2522 7.74778 16 8.66667 16H15.3333C16.2522 16 17 15.2522 17 14.3333V10.4444V9.33333V7.66667C17 6.74778 16.2522 6 15.3333 6Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }